import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";

import VisibilityIcon from "@material-ui/icons/Visibility";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const EventView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="View Exhibition"
    >
      <Container maxWidth="lg">
        <PageHeader
          icon={<VisibilityIcon />}
          title="View Exhibition"
          subtitle="View exhibition information and items"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>
      </Container>
    </Page>
  );
};

export default EventView;